<script setup>
import { ref, defineEmits } from 'vue';
import { useVideobotContentStore, useGlobalStateStore } from '../../../../store';
import TextContent from './TextContent.vue';
import PdfContent from './PdfContent.vue';
import VideoContent from './VideoContent.vue';

const videobotContent = useVideobotContentStore();
const globalStateStore = useGlobalStateStore();
const typeContent = ref('')

const items = ref(videobotContent.videobotContent.acolhimento)
const selectedItem = ref(null)

defineEmits(["close-list"])

function openContent(item, i) {
    typeContent.value = item.type
    item.viewed = true;
    selectedItem.value = item
    seeContent(i)
}

function seeContent(key) {
    globalStateStore.setViewContent('acolhimento', key);
}

</script>

<template>
    <div id="trilha-de-acolhimento">
        <div class="header">
            <div style="display: flex; flex-direction: column; align-items: start; width: 60%;">
                <v-btn @click="$emit('close-list')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Trilha de acolhimento</p>
            </div>


            <img style="width: 40%;"
                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/250edb9e-a7e0-4a6b-bc90-01dbce5df767.svg"
                alt="">

        </div>

        <v-card variant="flat" class="mx-auto" max-width="300" style="margin-top: 5%;">
            <v-list>
                <v-list-item height="60px" class="jb-save" :data-source="i" @click="openContent(item, i)" v-for="(item, i) in items" :key="i" :value="item">
                    <template v-slot:prepend>
                        <div class="icon-wrapper" v-if="item.type == 'text'">
                            <img style="width: 20px;"
                                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/10d4affa-0770-43f1-8fa5-7561f064e83d.svg"
                                alt="">
                        </div>
                        <div class="icon-wrapper" v-if="item.type == 'pdf'">
                            <img style="width: 20px;"
                                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/eb6a15ba-b883-4fdc-ab58-424c45287fb1.svg"
                                alt="">
                        </div>
                        <div class="icon-wrapper" v-if="item.type == 'video'">
                            <img style="width: 20px;"
                                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/eb6a15ba-b883-4fdc-ab58-424c45287fb1.svg"
                                alt="">
                        </div>

                        <v-list-item-title style="margin-left: 20px;" v-text="item.title"></v-list-item-title>
                    </template>

                    <template v-slot:append>
                        <img v-if="!item.viewed" style="margin-right: 10px;"
                            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/3f0db893-ff35-49d3-aad8-d28b39d5e1cb.svg"
                            alt="">
                        <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
                            alt="">
                    </template>
                </v-list-item>

            </v-list>
        </v-card>
    </div>

    <TextContent :item="selectedItem" @close-content="typeContent = ''" v-if="typeContent == 'text'" />
    <PdfContent :item="selectedItem" @close-content="typeContent = ''" v-if="typeContent == 'pdf'" />
    <VideoContent :item="selectedItem" @close-content="typeContent = ''" v-if="typeContent == 'video'" />
</template>

<style scoped>
#trilha-de-acolhimento {
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 1;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
}

.submenu-title {
    color: white;
    margin-top: 15px;
    font-size: 20px;
    text-align: start;
    margin-left: 20%;
}

.icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
}
</style>